/**
 * Created on 02/9/19.
 */
import offeringSummary from './offering-summary';
import incomeAndExpenses from './income-and-expenses';
import expenses from './expenses';
import rentRollHeader from './rent-roll-header';
import {rentRoll} from './rent-roll';
import sumedRentRoll from './sumed-rent-roll';
import reimbursementsHeader from './reimbursements-header';
import {reimbursements} from "./reimbursements";
import sumedReimbursements from './sumed-reimbursements';

export default {
    name: 'Marketing',
    tables: {
        'offering-summary': offeringSummary,
        'income-and-expenses': incomeAndExpenses,
        'expenses': expenses,
        'rent-roll-header': rentRollHeader,
        'rent-roll': rentRoll,
        'sumed-rent-roll': sumedRentRoll,
        'reimbursements-header': reimbursementsHeader,
        'reimbursements': reimbursements,
        'sumed-reimbursements': sumedReimbursements,
    }
};